import React from 'react'
import { Theme } from '@mui/material/styles'

import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    '&:not(:first-child)': {
      marginTop: theme.spacing(2),
    },
  },
}))

const Section: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { classes } = useStyles()
  return <div className={classes.root}>{children}</div>
}

export default Section
